import { useQuery } from '@apollo/client/react';
import { Box, Center, Heading, Spinner, Text } from '@chakra-ui/react';
import { SidebarNestedNavList, SidebarNestedNavListSection } from '@src/components/sco/SidebarNestedNavList';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoPlaybookPage, ScoPlaybookSection } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useMemo } from 'react';
const SHOW_PAGES = true;
export const SinglePlaybookNav = (props: {
  playbookSlug: string;
}) => {
  const query = useQuery(gql`
      query ($playbookSlug: String!) {
        scoPlaybook(slug: $playbookSlug) {
          id
          title
          slug
          sections {
            id
            title
            slug
            badge
            pages {
              id
              title
              content
            }
          }
        }
      }
    `, {
    variables: {
      playbookSlug: props.playbookSlug
    }
  });
  const playbook = query.data?.scoPlaybook;
  const navSections = useMemo<SidebarNestedNavListSection[]>(() => {
    if (!playbook) {
      return [];
    }
    return playbook.sections.map((section: ScoPlaybookSection, sectionIndex) => {
      return {
        title: `${sectionIndex + 1}. ${section.title}`,
        href: `/playbooks/${playbook.slug}/${section.slug}`,
        items: SHOW_PAGES ? section.pages.map((page: ScoPlaybookPage) => {
          return {
            title: page.title,
            href: `/playbooks/${playbook.slug}/${section.slug}#page-${page.id}`
          };
        }) : null
      };
    });
  }, [query.data?.scoPlaybook?.id]);
  if (!playbook) {
    return <Center padding={'1em'}>
        <Spinner />
      </Center>;
  }
  return <Box padding={'1em'}>
      <Box bgColor={'colorPalette.subtle'} borderRadius={'md'} marginBottom={'1em'} padding={'1em'}>
        <Text asChild color={'colorPalette.fg/50'} textStyle={'label'}>
          <NextLink href={'/playbooks'}>PLAYBOOK</NextLink>
        </Text>
        <Heading fontSize={'lg'} fontWeight={'semibold'}>
          <NextLink href={`/playbooks/${playbook.slug}`}>{playbook.title}</NextLink>
        </Heading>
      </Box>
      <SidebarNestedNavList accordionBehavior={'navigate-and-expand'} sections={navSections} />
    </Box>;
};